import {
  Create,
  SimpleForm,
  TextInput,
  required,
  SelectInput,
} from 'react-admin';
import { SliderInput } from '../../../../entities/SliderInput/ui/SliderInput';
import styles from './../ModelEdit/styles.module.scss';

export const ModelCreate = () => (
  <Create redirect="show">
    <SimpleForm>
      <TextInput source="name" fullWidth label="Имя" />
      <SelectInput
        source="data_type"
        fullWidth
        label="Тип модели"
        choices={[
          { id: 'assistant', name: 'Асистент' },
          { id: 'custom', name: 'Кастомный' },
        ]}
      />
      <TextInput
        label="Промпт"
        variant="outlined"
        multiline
        minRows={4}
        maxRows={6}
        source="prompt"
        fullWidth
        placeholder="Введите текст промпта"
        validate={[required('Обязательно для заполнения')]}
      />
      <SliderInput
        aria-labelledby="prompt-slider"
        valueLabelDisplay="auto"
        step={0.05}
        source="temperature"
        marks
        min={0}
        max={1}
        controlClassName={styles.PromptSlider}
      />
    </SimpleForm>
  </Create>
);
